import { useEffect, useState } from "react";
import "./Classroom.css";
import tutorImg from "./assets/teacher_4.png";

export default function Classroom() {

  const [data, setData] = useState({
    meet: "",
    topic: "",
    materials: []
  });

  useEffect(() => {
    fetch("https://script.google.com/macros/s/AKfycbxLKo5FCwnSPxPuZc_0gUUC86-ix90x3F78AiYNecXGPJKr0IVNPoCDIIrDWnnIVWUMPQ/exec")
      .then(res => res.json())
      .then(res => setData(res))
      .catch(() => console.log("Error fetching data"));
  }, []);

  const joinClass = () => {
    if (data.meet) {
      window.open(data.meet, "_blank");
    } else {
      alert("Class not started yet");
    }
  };

  const openMaterial = () => {
    if (data.materials.length > 0) {
      window.open(data.materials[0].link, "_blank");
    } else {
      alert("No materials available");
    }
  };

  return (
    <div className="classroom-page">

      {/* CENTER CARD */}
      <div className="lesson-card">

        <h2>Welcome 👋</h2>
        <p>Ready to learn something new today?</p>
        <p>Tutor: <b>Shifa K</b></p>

        <p className="material-label">📄 Learning Materials</p>

        {/* BUTTONS */}
        <div className="btn-row">
          <button className="start-btn" onClick={joinClass}>
            🔴 Join BCI Live Class
          </button>

          <button className="notes-btn" onClick={openMaterial}>
            📄 Materials
          </button>
        </div>

      </div>

      {/* TUTOR IMAGE */}
      <img src={tutorImg} alt="Tutor" className="tutor-img" />

      {/* CHAT BUTTON */}
      <button className="ask-btn">💬 Ask Rhea</button>

    </div>
  );
}